<template lang="pug">
div.filterSelect.accordion(id="accordion")
  div
    span.multipleFiltersTree__text {{ t("components.forms.mutiple_filters_tree.multiple_msg") }}

  forms-filters-tree-vue.filter(
    v-for="node in sortedNodes",
    :filter_name="node.name",
    :node="node",
    :key="node.name",
    :opened_children="openedChildrenByNode(node)"
    :show_header="uniqueFilterNode()",
    :is_document_view="true",
    @redirect:search="redirectSearch",
    :expanded_default="shouldExpand(node.id)"
  )
</template>

<script>
import mixins from "common/mixins"

export default {
  name: "forms-multiple-filters-tree-vue",
  props: {
    nodes: { type: Array, default: () => [] },
    filterNodes: { type: Array, default: () => [] },
    current_filter_id: { type: String, default: () => '' }
  },
  components: {
    "forms-filters-tree-vue": () =>
      import(/* webpackChunkName: "[request]" */ "../forms/FiltersTree.vue"),
  },
  mixins: [mixins.translate],
  methods: {
    openedChildrenByNode(node) {
      let filter_node = this.filterNodes.find((it) =>
        it.id == node.id
      );
      if(filter_node){
        return filter_node.opened_children
      }
      return []
    },
    uniqueFilterNode(){
      return this.filterNodes.length == 1
    },
    redirectSearch(filter_value,node){
      this.$emit('redirect:search', filter_value, node)
    },
    shouldExpand(node_id){
      return node_id == this.current_filter_id
    },
  },
  computed: {
    sortedNodes(){
      let index = this.nodes.findIndex(node => node['id'].toLowerCase() == this.current_filter_id.toLowerCase())
      if(index != -1) {
        let expandedNode = this.nodes.splice(index, 1)
        this.nodes.unshift(expandedNode[0])
      }
      return this.nodes
    }
  }
};
</script>
